import clsx from "clsx";
import PartnerFormGrid from "../container/PartnerFormGrid/PartnerFormGrid";

export interface PartnerPageProps {
    className?: string;
    style?: React.CSSProperties;
}

function PartnerPage({ className, ...rest }: PartnerPageProps) {
    return <PartnerFormGrid className={clsx("partner-page", className)} {...rest} />;
}

export default PartnerPage;
